var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-right"},[_c('vx-tooltip',{staticClass:"inline-flex",attrs:{"text":'Duplicate',"position":"bottom"}},[_c('feather-icon',{attrs:{"icon":"CopyIcon","svgClasses":`h-5 w-5 cursor-pointer`},on:{"click":function($event){return _vm.duplicatePromoRequest()}}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }